// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__3L2pp","spin":"Spinner_spin__ZVPBh"};